module.exports = __webpack_public_path__ + "static/media/picture.b7bc297f.svg";